module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Mortgage","removeConfirm":"Are you sure you want to delete this mortgage?"},"et":{"title":"Mortgage","removeConfirm":"Are you sure you want to delete this mortgage?"},"ru":{"title":"Mortgage","removeConfirm":"Are you sure you want to delete this mortgage?"}}')
  delete Component.options._Ctor
}
